import React from "react";

function Completed() {
  return (
    <div className="survey-page-container">
      <h3>Thank you for completing the survey!</h3>
    </div>
  );
}

export default Completed;
